var render = function render(){var _vm=this,_c=_vm._self._c;return _c('legal-page-layout',{attrs:{"title":_vm.$t('privacy.title'),"updated":_vm.$t('privacy.updated'),"paragraphs":_vm.$t('privacy.paragraphs')}})
}
var staticRenderFns = []

export { render, staticRenderFns }